require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-what-were-the-key-takeaways-from-the-afdbs-civil-society.json") })
        }
      }, "path---en-us-update-what-were-the-key-takeaways-from-the-afdbs-civil-society");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-what-were-the-key-takeaways-from-the-afdbs-civil-society!./.cache/json/en-us-update-what-were-the-key-takeaways-from-the-afdbs-civil-society.json
// module id = 857
// module chunks = 231608221292675